import { EHeadingsSelectionMode } from '@modules/documents';
import { AccessType } from '@modules/access/types';

export const FULL_PATH_TAGS_ITEM = Object.freeze({
  _id: 'tags',
  name: 'Regulatory tags',
  accessRight: AccessType.NONE,
});

export const SHOW_ASSOCIATED_FILES_DEFAULT_NUM = 2;

export const JURISDICTION_NOT_FOUND = 'Jurisdiction not found';
